let initState = {
	user_can_enrol: false,
	user_can_buy_membership: false,
	cart_available: false
};

const permissions = (state = initState, action) => {
	switch (action.type) {
		case 'USER_FAILURE':
		case 'MEMBER_FAILURE':
		case 'LOGOUT_SUCCESS':
			return initState;
		case 'UPDATE_PERMISSIONS':
			return action.response;
		default:
			return state;
	}
}

export default permissions